import ListProducts from "../product/ListProducts";
import GridProducts from "../product/GridProducts";
import FilterModal from "../modal/FilterModal";
import LayoutHandler from "../../context/LayoutHandler";
import {useEffect, useReducer, useRef, useState} from "react";
import { initialState, reducer } from "../product/FilterReducer";
import { itemApi } from "../../api";
import {useLocation, useNavigate} from "react-router-dom";
import AdminSpinner from "../components/AdminSpinner";
// import { useSearchParams } from "react-router-dom";


export default function Products({
                                      fullWidth = false,
                                      cardStyleClass,
                                      tooltipDirection,
                                     filterParams = {},
                                     onLoaded,
                                  }) {
    const [activeLayout, setActiveLayout] = useState(4);
    const [state, dispatch] = useReducer(reducer, initialState);
    // const [searchParams, setSearchParams] = useSearchParams();

    const [initialLoaded, setInitialLoaded] = useState(false);


    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const hasQueryInitialized = useRef(false);



    const navigate = useNavigate();
    const location = useLocation();
    // const clearAllFilters = () => {
    //     dispatch({ type: "CLEAR_FILTER" });
    //     navigate(location.pathname); // tüm query parametrelerini siler
    // };
    const clearAllFilters = () => {
        dispatch({ type: "CLEAR_FILTER" });
        navigate(location.pathname, { replace: true }); // URL query'lerini temizle
    };




    useEffect(() => {
        const applyQueryFilters = () => {
            dispatch({ type: "CLEAR_FILTER" });

            if (filterParams?.category) {
                dispatch({ type: "SET_CATEGORY", payload: filterParams.category });
            }
            if (filterParams?.gender) {
                dispatch({ type: "SET_GENDER", payload: filterParams.gender });
            }
            if (filterParams?.collection) {
                dispatch({ type: "SET_COLLECTION", payload: filterParams.collection });
            }
            if (filterParams?.size) {
                dispatch({ type: "SET_SIZE", payload: filterParams.size });
            }
        };

        applyQueryFilters();
    }, [location.search]); // Yönlendirme ile URL değiştiğinde tetiklenir





    const {
        price,
        availability,
        size,
        category,
        gender,

        filtered,
        sortingOption,
        sorted,

        currentPage,
        itemPerPage,
    } = state;


    useEffect(() => {
        //     const offset = document.querySelector("header")?.offsetHeight || 100;
        //     window.scrollTo({ top: offset + 500, behavior: "smooth" });
        window.scrollTo({ top: 550, behavior: "smooth" });
    }, [currentPage]);


    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);

            const queryParams = {
                page: currentPage,
                limit: itemPerPage,
                // size: size !== "All" ? size : undefined,
                size: filterParams.size ?? (size.length > 0 ? size : undefined),
                category: filterParams.category ?? (category !== "All" ? category : undefined),
                isStock:
                    availability === "In Stock"
                        ? true
                        : availability === "Unavailable"
                            ? false
                            : undefined,
                priceMin: price[0],
                priceMax: price[1],
                gender: filterParams.gender ?? (gender !== "All" ? gender : undefined),
                collection: filterParams.collection ?? undefined,
                search: filterParams.search ?? undefined,
            };



            try {
                const response = await itemApi.filterItems(queryParams);

                dispatch({ type: "SET_FILTERED", payload: response.data.items });
                setTotalPages(response.data.totalPages);



                if (!initialLoaded) {
                    onLoaded?.();
                    setInitialLoaded(true);
                }
            } catch (error) {
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [filterParams, currentPage, itemPerPage, availability, size, category, price, gender]);

    //

    useEffect(() => {
        if (filterParams?.category) {
            dispatch({ type: "SET_CATEGORY", payload: filterParams.category });
        }
        if (filterParams?.gender) {
            dispatch({ type: "SET_GENDER", payload: filterParams.gender });
        }
        if (filterParams?.collection) {
            dispatch({ type: "SET_COLLECTION", payload: filterParams.collection });
        }
    }, [filterParams]);



    const allProps = {
        ...state,
        setPrice: (value) => dispatch({ type: "SET_PRICE", payload: value }),

        // setSize: (value) => {
        //     value === size
        //         ? dispatch({ type: "SET_SIZE", payload: "All" })
        //         : dispatch({ type: "SET_SIZE", payload: value });
        // },
        toggleSize: (value) =>
            dispatch({ type: "TOGGLE_SIZE", payload: value }),


        setAvailability: (value) => {
            dispatch({ type: "SET_AVAILABILITY", payload: value });
        },

        setSortingOption: (value) =>
            dispatch({ type: "SET_SORTING_OPTION", payload: value }),

        setCurrentPage: (value) =>
            dispatch({ type: "SET_CURRENT_PAGE", payload: value }),



        setCategory: (value) =>
            dispatch({ type: "SET_CATEGORY", payload: value }),


        toggleGender: (value) => dispatch({ type: "TOGGLE_GENDER", payload: value }),





    };


    useEffect(() => {
        let sortedData = [...filtered];

        if (sortingOption === "Price Ascending") {
            sortedData.sort((a, b) => a.totalPrice - b.totalPrice);
        } else if (sortingOption === "Price Descending") {
            sortedData.sort((a, b) => b.totalPrice - a.totalPrice);
        } else if (sortingOption === "Title Ascending") {
            sortedData.sort((a, b) => a.name.localeCompare(b.name));
        } else if (sortingOption === "Title Descending") {
            sortedData.sort((a, b) => b.name.localeCompare(a.name));
        }

        dispatch({ type: "SET_SORTED", payload: sortedData });
    }, [filtered, sortingOption]);


    return (
        <>
            <section className="flat-spacing pt-0">
                <div className={fullWidth ? "container-full" : "container"}>
                    <div className="tf-shop-control">
                        <div className="tf-group-filter">
                            <a
                                href="#filterShop"
                                data-bs-toggle="offcanvas"
                                aria-controls="filterShop"
                                className="tf-btn-filter"
                            >
                                <span className="icon icon-filter" />
                                <span className="text">Filter</span>
                            </a>
                            <div className="tf-dropdown-sort" data-bs-toggle="dropdown">
                                <div className="btn-select">
                                    <span className="text-sort-value">{sortingOption}</span>
                                    <span className="icon icon-arr-down" />
                                </div>
                                <div className="dropdown-menu">
                                    {[
                                        "Sort by (Default)",
                                        "Title Ascending",
                                        "Title Descending",
                                        "Price Ascending",
                                        "Price Descending",
                                    ].map((elm, i) => (
                                        <div
                                            key={i}
                                            className={`select-item ${
                                                sortingOption == elm ? "active" : ""
                                            }`}
                                            onClick={() => allProps.setSortingOption(elm)}
                                            data-sort-value="best-selling"
                                        >
                                            <span className="text-value-item">{elm}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <ul className="tf-control-layout">
                            {/*bak*/}

                            <LayoutHandler
                                setActiveLayout={setActiveLayout}
                                activeLayout={activeLayout}
                            />
                        </ul>
                    </div>
                    <div className="wrapper-control-shop">

                        {loading ? (
                            <div className="flex justify-center items-center py-20">
                                <AdminSpinner />
                            </div>
                        ) : (
                            <>

                                <div className="meta-filter-shop">
                                    <div id="product-count-grid" className="count-text">
                                        <span
                                            className="count">{sorted.length}</span> Product{sorted.length > 1 ? "s" : ""} found
                                    </div>

                                    <div id="applied-filters">
                                        {(availability !== "All") && (
                                            <span
                                                className="filter-tag"
                                                onClick={() => allProps.setAvailability("All")}
                                            >
                                            <span className="remove-tag icon-close"/>
                                            Availability: {availability === "In Stock" ? "In Stock" : "Unavailable"}
                                        </span>
                                        )}

                                        {filterParams.search && (
                                            <span
                                                className="filter-tag"
                                                onClick={() => {
                                                    navigate(location.pathname, { replace: true }); // query temizlenir
                                                }}
                                            >
                                            <span className="remove-tag icon-close" />
                                            Search: {filterParams.search}
                                        </span>
                                        )}

                                        {price.join("-") !== [0, 2000].join("-") && (
                                            <span
                                                className="filter-tag"
                                                onClick={() => allProps.setPrice([0, 2000])}
                                            >
                <span className="remove-tag icon-close"/>
                Price: ${price[0]} - ${price[1]}
            </span>
                                        )}

                                        {(size.length > 0 ? size : filterParams.size ? [filterParams.size] : []).map((s) => (
                                            <span
                                                key={s}
                                                className="filter-tag"
                                                onClick={() => {
                                                    allProps.toggleSize(s);
                                                    navigate(location.pathname, {replace: true});
                                                }}
                                            >
                <span className="remove-tag icon-close"/>
                Size: {s}
            </span>
                                        ))}

                                        {(category !== "All" || filterParams.category) && (
                                            <span
                                                className="filter-tag"
                                                onClick={() => {
                                                    allProps.setCategory("All");
                                                    navigate(location.pathname, {replace: true});
                                                }}
                                            >
                <span className="remove-tag icon-close"/>
                Category: {category !== "All" ? category : filterParams.category}
            </span>
                                        )}

                                        {(gender.length > 0 ? gender : filterParams.gender ? [filterParams.gender] : []).map((g) => (
                                            <span
                                                key={g}
                                                className="filter-tag"
                                                onClick={() => {
                                                    allProps.toggleGender(g);
                                                    navigate(location.pathname, {replace: true});
                                                }}
                                            >
                <span className="remove-tag icon-close"/>
                Gender: {g}
            </span>
                                        ))}

                                        {filterParams.collection && (
                                            <span
                                                className="filter-tag"
                                                onClick={() => {
                                                    dispatch({type: "SET_COLLECTION", payload: null});
                                                    navigate(location.pathname, {replace: true});
                                                }}
                                            >
                <span className="remove-tag icon-close"/>
                Collection: {filterParams.collection}
            </span>
                                        )}
                                    </div>

                                    <button
                                        id="remove-all"
                                        className="remove-all-filters"
                                        onClick={clearAllFilters}
                                    >
                                        <i className="icon icon-close"/> Clear all filter
                                    </button>
                                </div>


                                {activeLayout == 1 ? (
                                    <div className="tf-list-layout wrapper-shop" id="listLayout">
                                        <ListProducts products={sorted}/>
                                        {/* Pagination */}
                                        <ul className="wg-pagination">
                                            {/* Geri butonu */}
                                            {currentPage > 1 && (
                                                <li>
                                                    <a
                                                        className="pagination-item"
                                                        onClick={() => allProps.setCurrentPage(currentPage - 1)}
                                                    >
                                                        <i className="icon-arr-left"/>
                                                    </a>
                                                </li>
                                            )}

                                            {/* Sayfa numaraları */}
                                            {Array.from({length: totalPages}, (_, i) => (
                                                <li key={i} className={currentPage === i + 1 ? "active" : ""}>
                                                    <a
                                                        className="pagination-item"
                                                        onClick={() => allProps.setCurrentPage(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </a>
                                                </li>
                                            ))}

                                            {/* İleri butonu */}
                                            {currentPage < totalPages && (
                                                <li>
                                                    <a
                                                        className="pagination-item"
                                                        onClick={() => allProps.setCurrentPage(currentPage + 1)}
                                                    >
                                                        <i className="icon-arr-right2"/>
                                                    </a>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                ) : (
                                    <div
                                        className={`wrapper-shop tf-grid-layout tf-col-${activeLayout}`}
                                        id="gridLayout"
                                    >
                                        <GridProducts
                                            cardStyleClass={cardStyleClass}
                                            products={sorted}
                                            tooltipDirection={tooltipDirection}
                                        />

                                        <ul className="wg-pagination">
                                            {/* Geri butonu */}
                                            {currentPage > 1 && (
                                                <li>
                                                    <a
                                                        className="pagination-item"
                                                        onClick={() => allProps.setCurrentPage(currentPage - 1)}
                                                    >
                                                        <i className="icon-arr-left"/>
                                                    </a>
                                                </li>
                                            )}

                                            {/* Sayfa numaraları */}
                                            {Array.from({length: totalPages}, (_, i) => (
                                                <li key={i} className={currentPage === i + 1 ? "active" : ""}>
                                                    <a
                                                        className="pagination-item"
                                                        onClick={() => allProps.setCurrentPage(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </a>
                                                </li>
                                            ))}

                                            {/* İleri butonu */}
                                            {currentPage < totalPages && (
                                                <li>
                                                    <a
                                                        className="pagination-item"
                                                        onClick={() => allProps.setCurrentPage(currentPage + 1)}
                                                    >
                                                        <i className="icon-arr-right2"/>
                                                    </a>
                                                </li>
                                            )}
                                        </ul>


                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </section>
            <FilterModal allProps={allProps}/>
        </>
    );
}
